import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { capitalCase, sentenceCase } from "change-case-all";
import { Grid, Typography } from "@mui/material";

import Connections from "./ConnectionList";
import ActionButton from "./ActionButtons";
import { colors } from "../../css components/Style";
import { PageHeader, Paper } from "../../../components";
import FormOne from "../create campaign components/campaign form components/CreateCampaignFirstForm";
import FormTwo from "../create campaign components/campaign form components/CreateCampaignSecondForm";
import FormThird from "../create campaign components/campaign form components/CreateCampaignThirdForm";
import FormFifth from "../create campaign components/campaign form components/CreateCampaignFifthForm";
import FormSeventh from "../create campaign components/campaign form components/PreferredCampaignChannel";
import FormEighth from "../create campaign components/campaign form components/SelectCampaignChannel";
import ChangeCampaignStatusDialog from "./change campaign status components/ChangeCampaignStatusDialog";

export default function CampaignForm({
  categories,
  audiences,
  formikProps,
  component = "",
  brandDetails,
  audienceData,
  connections,
  setEditState,
  editState,
  preferredChannels,
  setBrandDetails,
  setConnections,
  setRetry,
  retry,
  audienceSizing,
  setAudienceSizing,
  agents,
}) {
  const [brandIdentity, setBrandIdentity] = useState(false);
  const { activeBrand } = useSelector((state) => state.memberDetails);

  const [changeCampaignStatusDialog, setChangeCampaignStatusDialog] =
    useState(false);

  useEffect(() => {
    if (formikProps.values.brandID) {
      if (parseInt(formikProps.values.brandID) !== parseInt(activeBrand.ID)) {
        setBrandIdentity(true);
      }
    }
  }, [formikProps.values.brandID, activeBrand.ID]);

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <PageHeader
          pageName={"Campaign Details"}
          pageHeader={formikProps.values.campaign_name.value}
          buttons={[
            <ActionButton
              formikProps={formikProps}
              editState={editState}
              setEditState={setEditState}
              ID={formikProps.values.campaignID}
              audienceSizing={audienceSizing}
              setAudienceSizing={setAudienceSizing}
            />,
          ]}
        />
      </Grid>

      <Grid size={12}>
        <Paper>
          <Grid
            item
            container
            justifyContent={"space-between"}
            alignItems={"center"}
            xs={12}
          >
            <Typography variant="h5" style={{ color: colorPicker() }}>
              {capitalCase(
                formikProps.values.campaignStatus?.replace(/g_/, " ")
              )}{" "}
              ({formikProps.values.statusApproval || ""})
            </Typography>
          </Grid>
        </Paper>
      </Grid>

      {connections.length > 0 && (
        <Grid size={12}>
          <Paper>
            <Grid size={12}>
              <Typography variant="h4" color={colors.purple}>
                Connections
              </Typography>
            </Grid>
            <Connections
              retry={retry}
              setRetry={setRetry}
              connections={connections}
              setConnections={setConnections}
              formikProps={formikProps}
            />
          </Paper>
        </Grid>
      )}

      <Grid size={12}>
        <Paper gridSpacing={6}>
          <FormOne
            categories={categories}
            brandDetails={brandDetails}
            formikProps={formikProps}
            editState={editState}
            component={component}
            setBrandDetails={setBrandDetails}
            brandIdentity={brandIdentity}
          />
        </Paper>

        <Paper gridSpacing={6}>
          <FormTwo
            formikProps={formikProps}
            audiences={audiences}
            editState={editState}
            component={component}
            brandIdentity={brandIdentity}
            audienceData={audienceData}
          />
        </Paper>

        <Paper gridSpacing={6}>
          <FormThird
            brandIdentity={brandIdentity}
            formikProps={formikProps}
            editState={editState}
            component={component}
          />
        </Paper>

        <Paper gridSpacing={6}>
          <FormSeventh
            agents={agents}
            component="superadmin"
            editState={editState}
            formikProps={formikProps}
            preferredChannels={preferredChannels}
          />

          {formikProps.values?.pref_campaign_channel?.value?.length !== 0 && (
            <FormEighth
              agents={agents}
              formikProps={formikProps}
              editState={editState}
              brandDetails={brandDetails}
            />
          )}
        </Paper>

        <Paper gridSpacing={6}>
          <FormFifth
            formikProps={formikProps}
            editState={editState}
            component={component}
            brandIdentity={brandIdentity}
          />
        </Paper>

        <ChangeCampaignStatusDialog
          formikProps={formikProps}
          changeCampaignStatusDialog={changeCampaignStatusDialog}
          setChangeCampaignStatusDialog={setChangeCampaignStatusDialog}
        />
      </Grid>
    </Grid>
  );

  function colorPicker() {
    let color;

    if (
      formikProps.values.campaignStatus === "REQUESTED" ||
      formikProps.values.campaignStatus === "CREATED" ||
      formikProps.values.campaignStatus === "APPROVAL_REQUESTED" ||
      formikProps.values.campaignStatus === "LIVE_REQUESTED"
    ) {
      color = colors.warning;
    }

    if (
      formikProps.values.campaignStatus === "OFFER_ACCEPTED" ||
      formikProps.values.campaignStatus === "ACTIVE" ||
      formikProps.values.campaignStatus === "ACCEPTED" ||
      formikProps.values.campaignStatus === "PARTIAL_ACCEPTED" ||
      formikProps.values.campaignStatus === "SIZE_READY"
    ) {
      color = colors.success;
    }

    if (
      formikProps.values.campaignStatus === "INITIATED" ||
      formikProps.values.campaignStatus === "SIZING_IN_PROGRESS"
    ) {
      color = colors.purple;
    }

    if (
      formikProps.values.campaignStatuss === "REJECTED" ||
      formikProps.values.campaignStatus === "Expired" ||
      formikProps.values.campaignStatus === "FAILED"
    ) {
      color = colors.error;
    }

    if (formikProps.values.campaignStatus === "READY") {
      color = colors.success;
    }

    return color;
  }
}
